/**
 * @file index.tsx
 *
 * @fileoverview Renders a button that shows the original ad for the job.
 */
import React from 'react';
import { LinkButton } from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { analyticsDispatch, EVENTS } from '~/jobiqo/lib/analytics';
import { getJobDimensions } from '~/jobiqo/components/Job/utils/job_analytics';
import { Job } from '~/jobiqo/types/types';
import { FormattedMessage } from 'react-intl';
import NextLink from 'next/link';

interface OriginalAdButtonProps {
  /**
   * The source of the original ad.
   */
  src: string;
  /**
   * The job to show original ad for.
   */
  job: Job;
  /**
   * Custom button text.
   */
  customButtonText?: string | React.ReactNode;
}

export default function OriginalAdButton({
  src,
  job,
  customButtonText,
}: OriginalAdButtonProps) {
  return (
    <LinkButton
      linkElement={NextLink}
      buttonStyle="primary"
      href={src}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() =>
        analyticsDispatch(
          EVENTS.VIEW_ORIGINAL_AD_BTN_CLICK,
          getJobDimensions(job),
        )
      }
    >
      {customButtonText ? (
        customButtonText
      ) : (
        <FormattedMessage id="job_original_ad" defaultMessage="Original Ad" />
      )}
    </LinkButton>
  );
}
